import Vue from 'vue'
import * as mutationTypes from './mutation-types'
import { SERVICE_EVENTS, STATUS_FINISHED } from '@/consts/services'

export default {
  [mutationTypes.SERVICE_SET_ACTIVE]: (state, service) => {
    state.active = service && service.status === STATUS_FINISHED ? null : service
  },
  [mutationTypes.SERVICE_SET_EVENT]: (state, { target, eventData }) => {
    if (!eventData) return
    const _target = target || _.get(state, ['active'], {})
    const serviceEvents = _.get(_target, [SERVICE_EVENTS], [])
    const i = _.findIndex(serviceEvents, { id: eventData.id })
    if (i === -1) {
      serviceEvents.push(eventData)
    } else {
      serviceEvents.splice(i, 1, eventData)
    }
    if (!_target[SERVICE_EVENTS]) {
      Vue.set(_target, SERVICE_EVENTS, serviceEvents)
    }
  }
}
